<template>
    <div class="white-bg">
        <div class="topSearch">
            <router-link :to="{path:'/index'}" tag="div" class="fl logo"><img src="../../assets/images/logo.png" alt="logo"></router-link>
            <div  v-show="isShow=='3'||isShowSearch" class="fl search-cont">
                <select class="search-list" ref="typeName" v-model="currentOneTypeId" placeholder="请选择" @change="getOneTypeName">
                    <option v-for="(item,index) in oneTypeList" :value="item.id" :key="index">{{item.typeName}}</option>
                </select>
                <input type="text" class="select-inp" placeholder="请输入关键字" v-model="searchKey">
                <button type="button" class="btn-search" @click="getSearchGoodsList()">搜索</button>
            </div>
            <el-button v-show="isShow=='1'" round class="fr btn-addArticle" @click="goAddArticle()"><i class="el-icon-edit"></i>写文章</el-button>
            <el-button v-show="isShow=='2'" round class="fr btn-addArticle" @click="isShowReleaseDialog=true"><i class="el-icon-camera-solid"></i>发布</el-button>

            <release-dialog :releaseDialogVisible="isShowReleaseDialog"  @cancelDialog="cancelDialog"></release-dialog>
        </div>
    </div>

</template>

<script>
    import releaseDialog from '../../components/dialog/release'
    import {getIndexOneType} from '../../api/goods'
    export default {
        name: 'topSearch',
        data(){
            return {
                isShowReleaseDialog:false,//是否显示发布朋友圈弹窗
                oneTypeList:[],//一级分类列表
                searchKey:'',//关键字搜索
                current:1,//当前页
                size:20,//显示条数
                goodsList:[],//商品列表
                currentOneTypeId:'',
                currentOneTypeName:''
            }
        },
        components:{
            releaseDialog
        },
        props:{
            isShowSearch:{
                type:Boolean,
                default:true
            }
        },
        computed: {
            isShow(){
                const matched = this.$route.matched;
                let type;
                for(let i = 0; i < matched.length ; i++ ) {
                    if(matched[i].path.indexOf('article')!==-1){
                        type='1';
                    }else if(matched[i].path.indexOf('friends')!==-1){
                        type='2';
                    }else {
                        if(this.isShowSearch==false){
                            type='4';
                        }else {
                            type='3';
                        }

                    }
                }
                return type
            }
        },
        mounted(){
            this.getIndexOneType();
        },
        methods:{
            getOneTypeName(event){
                if(String(event.target.value).length === 0) return;
                this.oneTypeList.forEach((item) =>{
                    if(item.id == event.target.value){
                        this.currentOneTypeName = item.typeName;
                        return ;
                    }
                });
            },
            cancelDialog(){
                this.isShowReleaseDialog=false;
            },
            getIndexOneType(){
                getIndexOneType().then(res=>{
                    this.oneTypeList=res.data;
                    this.currentOneTypeId=this.oneTypeList[0].id;
                    this.currentOneTypeName = this.oneTypeList[0].typeName;
                })
            },
            getSearchGoodsList(){
                let params={
                    oneTypeId:this.currentOneTypeId,
                    oneTypeName:this.currentOneTypeName,
                    goodsName:this.searchKey,
                    /*twoTypeId:'',
                    twoTypeName:''*/
                }
                if(params.goodsName==''){
                    delete params.goodsName
                }
                this.$router.push({
                    path:'/search',
                    query:params
                })
            },
            goAddArticle(){
                this.$router.push({ path: '/article/add' })
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import '../../assets/css/common';
    .topSearch{
        @include main-content;
        overflow: hidden;
        padding:15px 0 30px;
        .logo{
            width:195px;
            height:48px;
            margin-right:153px;
            cursor: pointer;
        }
        .search-cont{
            margin-top:5px;
            border:2px solid $main-color;
            line-height:34px;
            .search-list{
                border:none;
                width:60px;
                color:#000000;
                font-weight: 600;
                margin-left:5px;
            }
            .select-inp{
                width:306px;
                padding-left:10px;
                line-height:30px;
            }
            .btn-search{
                float: right;
                height:35px;
                width:85px;
                background-color:$main-color;
                color: #ffffff;
            }
        }
    }


</style>
<style lang="scss">
    @import '../../assets/css/common';
    .btn-addArticle.el-button{
        background-color:$main-color;
        color:#ffffff;
        border:none;
        margin-right:80px;

    }
    .btn-addArticle.el-button.is-round{
        width:140px;
        height:48px;
        font-size:20px;
        -webkit-border-radius: 24px;
        -moz-border-radius: 24px;
        border-radius:24px;
    }
    .btn-addArticle.el-button.is-round:hover{
        color:#ffffff;
        background-color:$main-color;
    }
</style>
